<template>
  <div>
    <div v-for="item in form" :key="item.uid">
      <public-form-item
        :itemData="item"
        :answers="completedForm"></public-form-item>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import PublicFormItem from './PublicFormItem'

export default {
  name: 'PublicFormModal',
  props: {
    form: {
      type: Array,
      default () {
        return []
      }
    },
    completedForm: {}
  },
  components: {
    'public-form-item': PublicFormItem
  },
  methods: {
  }
}
</script>
